import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface ITitleProps {
  text: string;
  maxWidth?: number;
}

export const Title: React.FC<ITitleProps> = ({ text, maxWidth }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['title'], styles[device])} style={maxWidth ? { maxWidth: `${maxWidth}px` } : {}}>
      {text}
    </div>
  );
};
